import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "justify-content"
    }}>{`justify-content`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v3.0`}</p>
    <p>{`Supported values are `}<inlineCode parentName="p">{`flex-start`}</inlineCode>{`, `}<inlineCode parentName="p">{`flex-end`}</inlineCode>{`, `}<inlineCode parentName="p">{`center`}</inlineCode>{`, `}<inlineCode parentName="p">{`space-between`}</inlineCode>{`, `}<inlineCode parentName="p">{`space-around`}</inlineCode>{`, `}<inlineCode parentName="p">{`stretch`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/justify-content"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/justify-content`}</a></p>
    <p><strong parentName="p">{`Example`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.someElement {
    justify-content: flex-start;
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      